import { fetchPaginatedAllGroups } from 'features/Group'
import { GetServerSideProps } from 'next'

import { createQueryClient, dehydrateState } from 'config/query'

export { GroupSearch as default } from 'features/Group'

export const getServerSideProps: GetServerSideProps = async () => {
  const queryClient = createQueryClient()
  const options = {}

  await queryClient.prefetchQuery(['Paginated-All-Groups', { options }], () =>
    fetchPaginatedAllGroups({ currentPage: 1, pageSize: 40, options })
  )

  return { props: { ...dehydrateState(queryClient) } }
}
